import Vue from "vue";
import Vuex from "vuex";
import { ulsname } from './services/localstate';

import {
  LoadUser,
  SaveStatePlugin,
  LoadLang,
  LoadCookie,
  GetSession,
  RemoveSession,
} from "./services/localstate";
import { Update } from "./services/user";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [SaveStatePlugin],
  state: {
    user: {},
    jwt: "", // Mevcut JWT
    carepJwt: "", // Yeni carepJwt ekliyoruz
    lang: "", // Varsayılan dil
  },
  mutations: {
    LOGOUT_USER(state) {
      state.user = null;
      state.jwt = null;
      state.carepJwt = null;
      localStorage.removeItem(ulsname); // Local storage'ı temizle
    },
    SET_JWT_TOKEN(state, token) {
      state.jwt = token; // JWT token'ı state'de sakla
    },
    SET_CAREP_JWT(state, token) {
      state.carepJwt = token; // carepJwt'yi state'de sakla
    },
    SET_LANG(state, lang) {
      state.lang = lang; // Dil state'ini güncelle
    },
    initialiseStore(state) {
      let user = LoadUser();
      if (user && user.jwt && GetSession()) {
        // Hem kullanıcı hem de oturum geçerliyse
        state.user = user;
        state.lang = LoadLang();
      } else {
        this.commit('LOGOUT_USER');
      }
    },
  },
  actions: {
    logout({ commit }) {
      commit("LOGOUT_USER");
      RemoveSession();
    },
    setLang({ commit }, lang) {
      commit("SET_LANG", lang);
    },
  },
  getters: {
    jwt: (state) => {
      if (state.user) {
        return state.user.jwt;
      } else {
        return "NA";
      }
    },
    carepJwt: (state) => {
      return state.carepJwt;
    },
    langindex: (state) => {
      if (state.lang === "AZ") return 0;
      else if (state.lang === "EN") return 1;
    },
  },
});